export default "__VITE_ASSET__BAqiwpEs__"